/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
export class EditBuilder {
    constructor(changeFamily, changeReceiver) {
        this.changeFamily = changeFamily;
        this.changeReceiver = changeReceiver;
    }
    /**
     * Subclasses add editing methods which call this with their generated edits.
     *
     * @sealed
     */
    applyChange(change) {
        this.changeReceiver(change);
    }
    enterTransaction() { }
    exitTransaction() { }
}
//# sourceMappingURL=editBuilder.js.map